module.exports = __webpack_public_path__ + "static/media/carroseg.c51702d7.png";